import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@services/authentication.service';
import { UserService } from '@services/user.service';
import { ConfigService } from '@services/config.service';
import { NotificationService } from '@services/notification.service';
import { RefDataService } from '@services/ref-data.service';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ADMIN_ROLE_ID } from '@shared/constants/constant';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false,
})
export class LoginComponent implements OnInit {
  returnUrl = '';
  urlOldBO: SafeResourceUrl = '';
  loading = false;
  isSubmitted = true;
  allLanguages = [];
  currentLanguage = '';
  form: UntypedFormGroup = new UntypedFormGroup({});
  token = '';

  constructor(
    private userService: UserService,
    private notificationService: NotificationService,
    private authenticationService: AuthenticationService,
    private refdataService: RefDataService,
    private configService: ConfigService,
    private translateService: TranslateService,
    private route: ActivatedRoute,
    private router: Router,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    this.allLanguages = this.configService.getAppConfig().availableLangs;
    this.currentLanguage = this.configService.getCurrentLanguage();
    if (this.route.snapshot.fragment && this.route.snapshot.fragment.startsWith('access_token=')) {
      this.getUrlParams(this.route.snapshot.fragment);
      this.getUser(this.token.split('&')[0]);
    }
    this.urlOldBO = this.sanitizer.bypassSecurityTrustResourceUrl(this.configService.getAppConfig().BOoldURL + '#/login?resetStorage=true');
  }

  login(): void {
    this.authenticationService.signIn();
  }

  getUser(token: string): void {
    this.authenticationService.loginWithToken(token).subscribe(
      () => {
        this.userService.getMe().subscribe(
          (profile: any) => {
            profile.roles = [];
            const nbCommunityAsMarketAdmin = (profile.communityRoles ?? []).some((role: any) => role.role === 'MARKET_ADMIN');
            if (nbCommunityAsMarketAdmin) {
              profile.roles.push('market_admin', 'moderator');
            }
            // Get auth from connected user
            this.userService.getAuth().subscribe((authorizations: any) => {
              profile.authorizations = authorizations;

              // deprecated?
              if (authorizations && authorizations.role === ADMIN_ROLE_ID) {
                profile.roles.push('admin');
              }

              if (authorizations.groupingStatus) {
                // roles recettes
                this.refdataService
                  .getSpecificItemByKey('groupingStatuses', authorizations.groupingStatus)
                  .subscribe((groupingStatusDetails: any) => {
                    profile.groupingStatusDetails = groupingStatusDetails;
                    localStorage.setItem('profile', JSON.stringify(profile));
                    this.router.navigateByUrl(this.returnUrl);
                  });
              } else {
                localStorage.setItem('profile', JSON.stringify(profile));
                this.router.navigateByUrl(this.returnUrl);
              }
            });
          },
          (error: any) => {
            this.notificationService.sendError(this.translateService.instant('LOGIN_KO'));
            console.error(error);
            this.loading = false;
          },
        );
      },
      (error: any) => {
        this.notificationService.sendError(this.translateService.instant('LOGIN_KO'));
        console.error(error);
        this.loading = false;
      },
    );
  }

  changeLanguage(currentLanguage: string): void {
    this.configService.setCurrentLanguage(currentLanguage);
  }

  private getUrlParams(fragment: string): void {
    const fragmentParams = fragment.split('&');
    this.token = fragment.replace('access_token=', '');
    this.returnUrl = '/home';
    fragmentParams.some((param) => {
      if (param.startsWith('state=')) {
        this.returnUrl = atob(param.replace('state=', ''));
        return true;
      }
      return false;
    });
  }
}
